
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import Breadcrumb from "@/components/Breadcrumb/index.vue";
@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb
  }
})
export default class guanghua extends Vue {
  formatUpyunUrl = formatUpyunUrl;

  // pic1 = "/img/bfc52f4794d135e5b9024825fb87aba1.png";
  // pic1 = "/img/e9622e5e70b1a7ddce4918bb8a2fea7c.png";
  // pic1 = "/img/6be962bfafa61cca9bd3f5d2d4153810.png";
  pic1 = "/img/41aafc1772c4b4ed25c463dddb9cb2e6.png";
  pic2 = "/img/75f75e1e8c644f1959c48534557e5401.png";
  List = [
    { title: "数字化", url: "" },
    { title: "光华商学", url: "" }
  ];
  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "数字化方案陪跑，EPM企业绩效系统，绩效飞轮，ELP，微学，光华商学"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "专家，落地指导，规划，战略到执行，数字化转型方案，数字化，转型，数字化+，+数字化，数字化管理体系，业务转型，效率提升，持续增长，底层框架 ,全盘规划,从战略到执行全流程,过程,落地,问题,目标,调研,诊断,成果,复盘,赛道分析,企业位置,行业趋势,企业现状营收、盈利、规模、定位、生态位、战略控制点、价值主张,组织与人才,人才、组织盘点,结构、员工数,管理体系机制、制度、流程（尤其是业务主流程）、股权,差距分析,机会差距,业绩差距,三找,找差距、找不满、,找原因,梳理核心问题,对标对标杆,对历史数据,对BLM,目标共识,FCIL四个角度,企业培训,海量课程库，阶段目录，有序学习，要点检测，成果考核，加深理解，记忆实践，巧用关联，灵活使用，学，考，练，用，个人学习，缺乏体系，员工提升，管理层、电商、营销等不同团队缺乏专属课程资源，无法进行精准的专项培训，人才培养效率低下，因学习资源与培训体系不完善，导致关键岗位的能力成长缓慢，业务发展受到制约，人才培养的滞后，最终成为企业创新与增长步伐的瓶颈，实力名师，体系化学习，结构化知识体系，精品课，试听"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
